import React from "react";
import {
  Card
} from "reactstrap";
import { connect } from "react-redux";

export const LogoCardComponent = ({ theme, dispatch, ...props }) => {
  console.log(theme)
  const background = theme["background_image_card"];
  //const url = `url("${background}")`
  return background && background !== '' ? (<Card className="py-5 d-md-down-none" style={{ backgroundImage: `url("${background}")`, display: 'block', backgroundSize: 'cover', backgroundPosition: 'center' }} />) : (<Card className="py-5" />)

};

const mapStateToProps = state => ({
  theme: { ...state.theme }
});

export const LogoCardComponentConnected = connect(mapStateToProps)(LogoCardComponent);
